(function overrideShopifyInstallments() {
  let attempts = 0;
  const maxAttempts = 40; // Try for 20 seconds
  const interval = 500;

  function tryApplyStyles() {
    const termsEls = document.querySelectorAll('shopify-payment-terms');

    if (termsEls.length > 0) {
      termsEls.forEach(el => {
        if (el.shadowRoot) {
          el.shadowRoot.querySelectorAll('*').forEach(inner => {
            try {
              inner.style.color = 'white';
              inner.style.fill = 'white';
            } catch (e) {
              // Avoid breaking on read-only properties
            }
          });
        }
      });

      return; // Done
    }

    // Retry if not found
    attempts++;
    if (attempts < maxAttempts) {
      setTimeout(tryApplyStyles, interval);
    }
  }

  tryApplyStyles();
})();
